import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { Children, cloneElement } from 'react';
import styled from 'styled-components';
import { ArrowNavigationBase } from '@scp/ui-shared/components';
import { listItemBase, listBase } from './baseStyles';
import { getItemId } from './utils';
var List = styled.ul(_templateObject(), listBase);
var ListItem = styled.li(_templateObject2(), listItemBase);
export var Menu = function Menu(_a) {
  var children = _a.children,
      id = _a.id,
      useKeyboardArrowsNav = _a.useKeyboardArrowsNav,
      _a$role = _a.role,
      role = _a$role === void 0 ? 'menu' : _a$role,
      darkBackground = _a.darkBackground,
      roundedStyle = _a.roundedStyle,
      primary = _a.primary,
      otherProps = __rest(_a, ["children", "id", "useKeyboardArrowsNav", "role", "darkBackground", "roundedStyle", "primary"]);

  var items = Children.toArray(children);
  var itemIds = [];
  var list = React.createElement(List, Object.assign({}, otherProps, {
    primary: primary,
    id: id,
    role: useKeyboardArrowsNav ? role : undefined
  }), items.map(function (item, index) {
    if (!item || typeof item === 'boolean') return null;
    var itemId = item.props.id || getItemId(id, index);
    if (!item.props.nonFocusable) itemIds.push(itemId);
    return React.createElement(ListItem, {
      key: item.key || undefined,
      primary: primary
    }, cloneElement(item, {
      id: itemId,
      tabIndex: useKeyboardArrowsNav ? -1 : 0,
      role: useKeyboardArrowsNav ? 'menu-item' : undefined,
      darkBackground: darkBackground,
      roundedStyle: roundedStyle
    }));
  }));
  if (!useKeyboardArrowsNav) return list;
  return React.createElement(ArrowNavigationBase, {
    ids: itemIds,
    autoFocus: true
  }, list);
};